import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useClerk } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

export default function AdminShell({ children }) {
  const clerk = useClerk();
  const navigate = useNavigate();

  const handleAdminLogout = async () => {
    // Clear admin console credentials
    try {
      localStorage.removeItem('adminEmail');
      localStorage.removeItem('adminPassword');
    } catch {
      // ignore
    }

    // If user is also signed into Clerk, sign them out (best-effort).
    try {
      if (clerk?.signOut) await clerk.signOut();
    } catch {
      // ignore
    }

    navigate('/admin', { replace: true });
    // Hard reload to clear any in-memory state.
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#070812',
        backgroundImage:
          'radial-gradient(1200px 700px at 18% 10%, rgba(168,85,247,0.16) 0%, rgba(0,0,0,0) 55%), radial-gradient(1200px 700px at 85% 20%, rgba(34,211,238,0.10) 0%, rgba(0,0,0,0) 55%)',
        color: '#e9e7ff',
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          backgroundColor: 'rgba(7,8,18,0.82)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, md: 3 }, py: 1.5 }}>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <Box>
              <Typography sx={{ fontWeight: 950, letterSpacing: 0.6 }}>ADMIN CONSOLE</Typography>
              <Typography variant="caption" sx={{ color: 'rgba(233,231,255,0.70)' }}>
                User management • activity • payments
              </Typography>
            </Box>
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdminLogout}
              sx={{
                borderRadius: 999,
                textTransform: 'none',
                fontWeight: 700,
                borderColor: 'rgba(255,255,255,0.18)',
                color: 'rgba(233,231,255,0.92)',
                '&:hover': {
                  borderColor: 'rgba(255,255,255,0.28)',
                  backgroundColor: 'rgba(255,255,255,0.06)',
                },
              }}
            >
              Exit admin console
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box sx={{ maxWidth: 1280, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>{children}</Box>
    </Box>
  );
}

